// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function TerminatedAgentIconOverlay(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  return JsxRuntime.jsxs("span", {
    children: [
      size === "medium" ? JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "unavailable",
            size: 24,
            className: "text-tan-error-500"
          }),
          className: "absolute left-[38px] top-[33px] opacity-40"
        }) : (
          size === "small" ? JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(IconV5.make, {
                icon: "unavailable",
                size: 20,
                className: "text-tan-error-500"
              }),
              className: "absolute left-[34px] top-[29px] opacity-40"
            }) : (
              size === "xxSmall" ? JsxRuntime.jsx("span", {
                  children: JsxRuntime.jsx(IconV5.make, {
                    icon: "unavailable",
                    size: 12,
                    className: "text-tan-error-500"
                  }),
                  className: "absolute left-[13px] top-[12px] opacity-40"
                }) : (
                  size === "xSmall" ? JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(IconV5.make, {
                        icon: "unavailable",
                        size: 18,
                        className: "text-tan-error-500"
                      }),
                      className: "absolute left-[25px] top-[21px] opacity-40"
                    }) : JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(IconV5.make, {
                        icon: "unavailable",
                        size: 36,
                        className: "text-tan-error-500"
                      }),
                      className: "absolute left-[57px] top-[49px] opacity-40"
                    })
                )
            )
        ),
      props.children
    ],
    className: "relative inline-block"
  });
}

let make = TerminatedAgentIconOverlay;

exports.make = make;
/* IconV5 Not a pure module */
